
import type { PropOptions } from 'vue';
import Vue from 'vue';
import AttachmentIcon from '@/assets/svg/attachment.vue.svg';
import type { IPostFile } from '@/types/community';
import warRoomSignUpMixin from '~/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

export default Vue.extend({
  name: 'WarRoomPostFilesAttached',
  components: {
    AttachmentIcon,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    files: {
      type: Array,
      required: true,
    } as PropOptions<Array<IPostFile>>,
  },
  data() {
    return {
      internalBaseUrl: process.env.internalBaseUrl,
    };
  },
  methods: {
    onFilesClick() {
      // @ts-ignore, method is from mixin
      if (!this.$auth.loggedIn) this.openWarRoomSignUpModal();
    },
    getFileHrefAttrs(file: IPostFile) {
      return this.$auth.loggedIn ? { href: file.url, target: '_blank', rel: 'nofollow noopener noreferrer' } : {};
    },
    isImage(url: string) {
      return url.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/);
    },
  },
});
